module.exports = __webpack_public_path__ + "static/media/6235.bac9858a.jpg";